import { ApiService, CustomHttpParams } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import { OrganisationLookupModel } from '../models/organisation-lookup.model';
import { OrganisationLookup } from '../types/organisation-lookup.type';

@Injectable({
  providedIn: 'root',
})
export class OrganisationLookupApiService extends ApiService {
  async getOrganisation(
    hasPermissions: boolean,
  ): Promise<OrganisationLookupModel | null> {
    const params = new CustomHttpParams({
      hasPermissions,
    });

    try {
      const response = await this.get<OrganisationLookupModel>(
        'Organisation/Unit/Lookup',
        OrganisationLookup,
        params,
      );

      return response != null ? new OrganisationLookupModel(response) : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving the organisations.',
      );
    }
  }

  async getOrganisationByRole(
    minimumPermissionRole: number,
  ): Promise<OrganisationLookupModel | null> {
    const params = new CustomHttpParams({
      minimumPermissionRole,
    });

    try {
      const response = await this.get<OrganisationLookupModel>(
        'Organisation/Unit/LookupFilterByRole',
        OrganisationLookup,
        params,
      );

      return response != null ? new OrganisationLookupModel(response) : null;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving the organisations.',
      );
    }
  }
}
